import { render, staticRenderFns } from "./ImportGroupTic.vue?vue&type=template&id=47c5d868"
import script from "./ImportGroupTic.vue?vue&type=script&lang=js"
export * from "./ImportGroupTic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports